var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Utils from '@datocms/rest-client-utils';
import BaseResource from '../../BaseResource';
var SubscriptionLimit = /** @class */ (function (_super) {
    __extends(SubscriptionLimit, _super);
    function SubscriptionLimit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get all the subscription limits
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/subscription-limit/instances
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    SubscriptionLimit.prototype.list = function () {
        return this.rawList().then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Get all the subscription limits
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/subscription-limit/instances
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    SubscriptionLimit.prototype.rawList = function () {
        return this.client.request({
            method: 'GET',
            url: '/subscription-limits',
        });
    };
    /**
     * Get a single subscription limit
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/subscription-limit/self
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    SubscriptionLimit.prototype.find = function (subscriptionLimitId) {
        return this.rawFind(Utils.toId(subscriptionLimitId)).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Get a single subscription limit
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/subscription-limit/self
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    SubscriptionLimit.prototype.rawFind = function (subscriptionLimitId) {
        return this.client.request({
            method: 'GET',
            url: "/subscription-limits/".concat(subscriptionLimitId),
        });
    };
    SubscriptionLimit.TYPE = 'subscription_limit';
    return SubscriptionLimit;
}(BaseResource));
export default SubscriptionLimit;
//# sourceMappingURL=SubscriptionLimit.js.map